<template>
    <div style="width: 100%;">
        <MainHeader @changeActiveStep="changeActiveStep"></MainHeader>
        <router-view class="layout-main" :style="{ minHeight: mainHeight + 'px' }" :activeName="activeName" />
        <MainFooter @changeActiveStep="changeActiveStep"></MainFooter>
        <!-- 回到顶部 -->
        <BackTop :height="140" :bottom="140"></BackTop>
    </div>
</template>

<script>
import MainHeader from "../components/MainHeader.vue";
import MainFooter from "../components/MainnFooter.vue";
export default {
    name: "App",
    components: {
        MainFooter,
        MainHeader,
    },
    data() {
        return {
            mainHeight: 0,
            activeName: "",
        };
    },
    created() {
        this.mainHeight = window.innerHeight - 270;
    },
    methods: {
        changeActiveStep(val) {
            this.activeName = val;
        },
    },
};
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

html,
body,
#app {
    width: 100%;
}

@media screen and (max-width: 999px) {
    .layout-main {
        min-height: auto;
    }
}

.to-top {
    padding: 10px;
    background: rgba(0, 153, 229, 0.7);
    color: #fff;
    text-align: center;
    border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/views/Index.vue